import { render, staticRenderFns } from "./PageEdicion.vue?vue&type=template&id=324771c6"
import script from "./PageEdicion.vue?vue&type=script&lang=js"
export * from "./PageEdicion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports